import MDBox from 'components/MDBox'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import localforage from 'localforage'
import Card from '@mui/material/Card'
import MDButton from 'components/MDButton'
import { Grid } from '@mui/material'
import MDTypography from 'components/MDTypography'
import Alert from '@mui/material/Alert'
import env from 'config'
import { useBrandInfo } from 'context/brand'
import Stack from '@mui/material/Stack'
import ghlLogo from '../../../../assets/images/ghl-logo.avif'
import stripeLogo from '../../../../assets/images/Stripe-Emblem.png'
import { useAgencyInfo } from 'context/agency'
import { useAppServices } from 'hook/services'
import Singleselect from './inputs/Singleselect'
import MDInput from 'components/MDInput'
import Loader from 'examples/Loader'
function Integration() {
  const [brand] = useBrandInfo()
  const [agency] = useAgencyInfo()
  const [settinngs_data, setsettinngs_data] = useState({})
  const [processing, setProcessing] = useState(false)
  const [loader, setloader] = useState(true)
  const [sessionkey, setsessionkey] = useState('')
  const Service = useAppServices();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      smart_directory_stripe_public_key: e.target.smart_directory_stripe_public_key.value,
      smart_directory_stripe_api_key: e.target.smart_directory_stripe_api_key.value,
    };
    if (settinngs_data?._id) {
      payload._id = settinngs_data._id
    }
    const { response } = await Service.super_admin_settings.create({ payload });
  };


  const getSettingsData = async () => {
    const { response } = await Service.super_admin_settings.get()

    if (response) {
      setsettinngs_data(response.data)
      setloader(false)
    } else {
      setloader(false)
    }
  }
  const onLoad = () => {
    getSettingsData()
  }
  useEffect(() => {
    onLoad()
  }, [])

  const scopes = [
    'users.readonly',
    'locations.readonly',
    'workflows.readonly',
    'locations/tags.readonly',
    'locations/tags.write',
    'oauth.write',
    'oauth.readonly',
    'surveys.readonly',
    'contacts.write',
    'contacts.readonly',
  ].join('');
  return (
    <MDBox pb={3}>
      {loader ? (
        <Loader />
      ) : (
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container mt={5} mb={2} justifyContent="center">
              <Grid item xs={11}>
                <MDBox pt={4} px={3}>
                  <div style={{ display: 'flex',gap:"50px" }}>
                    <MDBox sx={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                      <img src={ghlLogo} alt="logo" width={100} />

                      {settinngs_data?.ghl ? (
                        <MDButton
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: '100px' }}
                        >
                          <a
                            href={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.Location_ASSOCIATE}&client_id=694968832d8dea5c1f21e540-mjie1tq8&scope=locations.readonly+users.readonly+workflows.readonly+locations%2Ftags.readonly+contacts.readonly+contacts.write+surveys.readonly+oauth.readonly+oauth.write+locations%2Ftags.write&state=${encodeURIComponent("workflow")}`}
                            style={{ color: 'white' }}
                          >
                            Location Refresh
                          </a>
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: '100px' }}
                        >
                          <a
                            href={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.Location_ASSOCIATE}&client_id=694968832d8dea5c1f21e540-mjie1tq8&scope=locations.readonly+users.readonly+workflows.readonly+locations%2Ftags.readonly+contacts.readonly+contacts.write+surveys.readonly+oauth.readonly+oauth.write+locations%2Ftags.write&state=${encodeURIComponent("workflow")}`}
                            style={{ color: 'white' }}
                          >
                            Location connect
                          </a>
                        </MDButton>
                      )}
                    </MDBox>
                    <MDBox sx={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                      <img src={ghlLogo} alt="logo" width={100} />

                      {settinngs_data?.admin_ghl ? (
                        <MDButton
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: '100px' }}
                        >
                          <a
                            href={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.Location_ASSOCIATE}&client_id=694968832d8dea5c1f21e540-mjie1tq8&scope=locations.readonly+users.readonly+workflows.readonly+locations%2Ftags.readonly+contacts.readonly+contacts.write+surveys.readonly+oauth.readonly+oauth.write+locations%2Ftags.write&state=${encodeURIComponent("adminghl")}`}
                            style={{ color: 'white' }}
                          >
                            Location Refresh
                          </a>
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: '100px' }}
                        >
                          <a
                           href={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.Location_ASSOCIATE}&client_id=694968832d8dea5c1f21e540-mjie1tq8&scope=locations.readonly+users.readonly+workflows.readonly+locations%2Ftags.readonly+contacts.readonly+contacts.write+surveys.readonly+oauth.readonly+oauth.write+locations%2Ftags.write&state=${encodeURIComponent("adminghl")}`}
                            style={{ color: 'white' }}
                          >
                            Location connect
                          </a>
                        </MDButton>
                      )}
                    </MDBox>

                    <MDBox sx={{ display: 'flex', flexDirection: 'column', marginRight: '30px' }}>
                      <img src={ghlLogo} alt="logo" width={100} />

                      {settinngs_data?.agency_ghl ? (
                        <MDButton
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: '100px' }}
                        >
                          <a
                            href={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.ASSOCIATE}&client_id=69b43b52dfdccce079002023-mmp4hhxk&scope=agent-studio.readonly+agent-studio.write+associations.write+associations.readonly+associations%2Frelation.readonly+associations%2Frelation.write+blogs%2Fpost.write+blogs%2Fpost-update.write+blogs%2Fcheck-slug.readonly+blogs%2Fcategory.readonly+blogs%2Fauthor.readonly+blogs%2Fposts.readonly+blogs%2Flist.readonly+brand-boards%2Fdesign-kit.readonly+brand-boards%2Fdesign-kit.write+businesses.readonly+businesses.write+calendars.readonly+calendars.write+calendars%2Fevents.readonly+calendars%2Fevents.write+calendars%2Fgroups.readonly+calendars%2Fgroups.write+calendars%2Fresources.readonly+calendars%2Fresources.write+campaigns.readonly+companies.readonly+contacts.readonly+contacts.write+conversation-ai.readonly+conversation-ai.write+conversations.readonly+conversations.write+conversations%2Fmessage.readonly+conversations%2Fmessage.write+conversations%2Freports.readonly+conversations%2Flivechat.write+courses.write+courses.readonly+locations%2FcustomFields.readonly+locations%2FcustomFields.write+custom-menu-link.readonly+custom-menu-link.write+emails%2Fbuilder.write+emails%2Fbuilder.readonly+emails%2Fschedule.readonly+forms.readonly+forms.write+funnels%2Fredirect.readonly+funnels%2Fpage.readonly+funnels%2Ffunnel.readonly+funnels%2Fpagecount.readonly+funnels%2Fredirect.write+invoices.readonly+invoices.write+invoices%2Fschedule.readonly+invoices%2Fschedule.write+invoices%2Ftemplate.readonly+invoices%2Ftemplate.write+invoices%2Festimate.readonly+invoices%2Festimate.write+knowledge-bases.write+knowledge-bases.readonly+lc-email.readonly+links.readonly+links.write+locations.write+locations.readonly+locations%2FcustomValues.readonly+locations%2FcustomValues.write+locations%2Ftasks.readonly+locations%2Ftasks.write+recurring-tasks.readonly+recurring-tasks.write+locations%2Ftags.readonly+locations%2Ftags.write+locations%2Ftemplates.readonly+charges.readonly+charges.write+marketplace-installer-details.readonly+marketplace-external-auth-migration.write+medias.readonly+medias.write+oauth.write+oauth.readonly+objects%2Fschema.readonly+objects%2Fschema.write+objects%2Frecord.readonly+objects%2Frecord.write+opportunities.readonly+opportunities.write+payments%2Forders.readonly+payments%2Forders.write+payments%2Forders.collectPayment+payments%2Fintegration.readonly+payments%2Fintegration.write+payments%2Ftransactions.readonly+payments%2Fsubscriptions.readonly+payments%2Fcoupons.readonly+payments%2Fcoupons.write+payments%2Fcustom-provider.readonly+payments%2Fcustom-provider.write+phonenumbers.read+numberpools.read+products.readonly+products.write+products%2Fprices.readonly+products%2Fprices.write+products%2Fcollection.readonly+products%2Fcollection.write+documents_contracts%2Flist.readonly+documents_contracts%2FsendLink.write+documents_contracts_template%2FsendLink.write+documents_contracts_template%2Flist.readonly+saas%2Fcompany.read+saas%2Fcompany.write+saas%2Flocation.read+saas%2Flocation.write+snapshots.readonly+snapshots.write+socialplanner%2Foauth.readonly+socialplanner%2Foauth.write+socialplanner%2Fpost.readonly+socialplanner%2Fpost.write+socialplanner%2Faccount.readonly+socialplanner%2Faccount.write+socialplanner%2Fcsv.readonly+socialplanner%2Fcsv.write+socialplanner%2Fcategory.readonly+socialplanner%2Ftag.readonly+socialplanner%2Fstatistics.readonly+socialplanner%2Fcategory.write+socialplanner%2Ftag.write+store%2Fshipping.readonly+store%2Fshipping.write+store%2Fsetting.readonly+store%2Fsetting.write+surveys.readonly+twilioaccount.read+users.readonly+users.write+voice-ai-dashboard.readonly+voice-ai-agents.readonly+voice-ai-agents.write+voice-ai-agent-goals.readonly+voice-ai-agent-goals.write+wordpress.site.readonly+workflows.readonly&version_id=69b43b52dfdccce079002023`}
                            style={{ color: 'white' }}
                          >
                            Agency Refresh
                          </a>
                        </MDButton>
                      ) : (
                        <MDButton
                          variant="contained"
                          color="info"
                          size="small"
                          sx={{ width: '100px' }}
                        >
                          <a
                           href={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.ASSOCIATE}&client_id=69b43b52dfdccce079002023-mmp4hhxk&scope=agent-studio.readonly+agent-studio.write+associations.write+associations.readonly+associations%2Frelation.readonly+associations%2Frelation.write+blogs%2Fpost.write+blogs%2Fpost-update.write+blogs%2Fcheck-slug.readonly+blogs%2Fcategory.readonly+blogs%2Fauthor.readonly+blogs%2Fposts.readonly+blogs%2Flist.readonly+brand-boards%2Fdesign-kit.readonly+brand-boards%2Fdesign-kit.write+businesses.readonly+businesses.write+calendars.readonly+calendars.write+calendars%2Fevents.readonly+calendars%2Fevents.write+calendars%2Fgroups.readonly+calendars%2Fgroups.write+calendars%2Fresources.readonly+calendars%2Fresources.write+campaigns.readonly+companies.readonly+contacts.readonly+contacts.write+conversation-ai.readonly+conversation-ai.write+conversations.readonly+conversations.write+conversations%2Fmessage.readonly+conversations%2Fmessage.write+conversations%2Freports.readonly+conversations%2Flivechat.write+courses.write+courses.readonly+locations%2FcustomFields.readonly+locations%2FcustomFields.write+custom-menu-link.readonly+custom-menu-link.write+emails%2Fbuilder.write+emails%2Fbuilder.readonly+emails%2Fschedule.readonly+forms.readonly+forms.write+funnels%2Fredirect.readonly+funnels%2Fpage.readonly+funnels%2Ffunnel.readonly+funnels%2Fpagecount.readonly+funnels%2Fredirect.write+invoices.readonly+invoices.write+invoices%2Fschedule.readonly+invoices%2Fschedule.write+invoices%2Ftemplate.readonly+invoices%2Ftemplate.write+invoices%2Festimate.readonly+invoices%2Festimate.write+knowledge-bases.write+knowledge-bases.readonly+lc-email.readonly+links.readonly+links.write+locations.write+locations.readonly+locations%2FcustomValues.readonly+locations%2FcustomValues.write+locations%2Ftasks.readonly+locations%2Ftasks.write+recurring-tasks.readonly+recurring-tasks.write+locations%2Ftags.readonly+locations%2Ftags.write+locations%2Ftemplates.readonly+charges.readonly+charges.write+marketplace-installer-details.readonly+marketplace-external-auth-migration.write+medias.readonly+medias.write+oauth.write+oauth.readonly+objects%2Fschema.readonly+objects%2Fschema.write+objects%2Frecord.readonly+objects%2Frecord.write+opportunities.readonly+opportunities.write+payments%2Forders.readonly+payments%2Forders.write+payments%2Forders.collectPayment+payments%2Fintegration.readonly+payments%2Fintegration.write+payments%2Ftransactions.readonly+payments%2Fsubscriptions.readonly+payments%2Fcoupons.readonly+payments%2Fcoupons.write+payments%2Fcustom-provider.readonly+payments%2Fcustom-provider.write+phonenumbers.read+numberpools.read+products.readonly+products.write+products%2Fprices.readonly+products%2Fprices.write+products%2Fcollection.readonly+products%2Fcollection.write+documents_contracts%2Flist.readonly+documents_contracts%2FsendLink.write+documents_contracts_template%2FsendLink.write+documents_contracts_template%2Flist.readonly+saas%2Fcompany.read+saas%2Fcompany.write+saas%2Flocation.read+saas%2Flocation.write+snapshots.readonly+snapshots.write+socialplanner%2Foauth.readonly+socialplanner%2Foauth.write+socialplanner%2Fpost.readonly+socialplanner%2Fpost.write+socialplanner%2Faccount.readonly+socialplanner%2Faccount.write+socialplanner%2Fcsv.readonly+socialplanner%2Fcsv.write+socialplanner%2Fcategory.readonly+socialplanner%2Ftag.readonly+socialplanner%2Fstatistics.readonly+socialplanner%2Fcategory.write+socialplanner%2Ftag.write+store%2Fshipping.readonly+store%2Fshipping.write+store%2Fsetting.readonly+store%2Fsetting.write+surveys.readonly+twilioaccount.read+users.readonly+users.write+voice-ai-dashboard.readonly+voice-ai-agents.readonly+voice-ai-agents.write+voice-ai-agent-goals.readonly+voice-ai-agent-goals.write+wordpress.site.readonly+workflows.readonly&version_id=69b43b52dfdccce079002023`}
                            style={{ color: 'white' }}
                          >
                            Agency connect
                          </a>
                        </MDButton>
                      )}
                    </MDBox>
                  </div>

                  <MDBox mt={4} pb={5} component="form" onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <MDTypography variant="h5">Smart Directory Stripe Connection</MDTypography>
                        </Grid>
                        <Grid item xs={12}>
                          <MDInput
                            style={{ width: '100%' }}
                            label="Public Key"
                            placeholder="public key"
                            name="smart_directory_stripe_public_key"
                            defaultValue={settinngs_data?.smart_directory_stripe_public_key}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <MDInput
                            style={{ width: '100%' }}
                            label="Secret Key"
                            placeholder="Secret key"
                            name="smart_directory_stripe_api_key"
                            defaultValue={settinngs_data?.smart_directory_stripe_api_key}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          mt={4}
                          mb={"13rem"}
                          display={"flex"}
                          justifyContent={"flex-start"}
                        >
                          <MDButton variant="contained" color="info" type="submit">
                            save
                          </MDButton>
                        </Grid>
                      </Grid>
                    </MDBox>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </MDBox>
  )
}

export default Integration